import { LogLevel } from "@azure/msal-browser";

const SSO_TENANT_AUTHORITY =
  "https://login.microsoftonline.com/" + process.env.REACT_APP_SSO_TENET_ID;

// Use env var if set, otherwise use current origin + /auth
const redirectUri = process.env.REACT_APP_SSO_REDIRECTURI || window.location.origin + "/auth";

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_SSO_CLIENTID,
    authority: SSO_TENANT_AUTHORITY,
    redirectUri,
    postLogoutRedirectUri: process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URI || redirectUri,
  },
  cache: {
    cacheLocation: "sessionStorage",
    // GS-009: Added storeAuthStateInCookie for defense-in-depth against XSS
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level >= LogLevel.Warning) console.warn(message);
      },
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};
